import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

class HeroSlider {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.swiperEl = this.root.querySelector('[data-hero-swiper]');

        return true;
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        if (!this.swiperEl) return;

        this.swiper = new Swiper(this.swiperEl, {
            speed: 650,
            slidesPerView: 'auto',
            spaceBetween: 16,
            modules: [Autoplay],
            loop: true,
            /*autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },*/
        });
    }
}

const sections = document.querySelectorAll('[data-hero]');
const setHeroSlider = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new HeroSlider(el);
    });
};

setHeroSlider(sections);
